@file:OptIn(InternalResourceApi::class)

package klyph.sample.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/klyph.sample.generated.resources/"

@delegate:ResourceContentHash(1_856_735_058)
internal val Res.font._756d208b750e0e39c40c1e574c1fe9d92f522cbd: FontResource by lazy {
      FontResource("font:_756d208b750e0e39c40c1e574c1fe9d92f522cbd", setOf(
        ResourceItem(setOf(), "${MD}font/_756d208b750e0e39c40c1e574c1fe9d92f522cbd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-870_100_970)
internal val Res.font._75c454eefcd0110a37ccdad3e0ef0ffd286e7e98: FontResource by lazy {
      FontResource("font:_75c454eefcd0110a37ccdad3e0ef0ffd286e7e98", setOf(
        ResourceItem(setOf(), "${MD}font/_75c454eefcd0110a37ccdad3e0ef0ffd286e7e98.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(454_238_664)
internal val Res.font._7799fc4a0302119d4c12ddfc9b68629e0d81a27d: FontResource by lazy {
      FontResource("font:_7799fc4a0302119d4c12ddfc9b68629e0d81a27d", setOf(
        ResourceItem(setOf(), "${MD}font/_7799fc4a0302119d4c12ddfc9b68629e0d81a27d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_049_735_563)
internal val Res.font._78cbd767fb2e7a14b1bad1e72507edcbe070ec77: FontResource by lazy {
      FontResource("font:_78cbd767fb2e7a14b1bad1e72507edcbe070ec77", setOf(
        ResourceItem(setOf(), "${MD}font/_78cbd767fb2e7a14b1bad1e72507edcbe070ec77.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(539_469_490)
internal val Res.font._790ba64b9d18e276e24c23fca74454a44b40453a: FontResource by lazy {
      FontResource("font:_790ba64b9d18e276e24c23fca74454a44b40453a", setOf(
        ResourceItem(setOf(), "${MD}font/_790ba64b9d18e276e24c23fca74454a44b40453a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-90_195_894)
internal val Res.font._791bce4e8022d749ddbda4e34f8f27f4590f6263: FontResource by lazy {
      FontResource("font:_791bce4e8022d749ddbda4e34f8f27f4590f6263", setOf(
        ResourceItem(setOf(), "${MD}font/_791bce4e8022d749ddbda4e34f8f27f4590f6263.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-96_073_101)
internal val Res.font._7baf6a35b648cde51148e5558e672f31560909e8: FontResource by lazy {
      FontResource("font:_7baf6a35b648cde51148e5558e672f31560909e8", setOf(
        ResourceItem(setOf(), "${MD}font/_7baf6a35b648cde51148e5558e672f31560909e8.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_689_337_415)
internal val Res.font._7be772a88ffa33ed0eb5d518a1b8ebfd093edc49: FontResource by lazy {
      FontResource("font:_7be772a88ffa33ed0eb5d518a1b8ebfd093edc49", setOf(
        ResourceItem(setOf(), "${MD}font/_7be772a88ffa33ed0eb5d518a1b8ebfd093edc49.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(350_256_703)
internal val Res.font._7f239f13e0720376664a2c1850848ef3af415b92: FontResource by lazy {
      FontResource("font:_7f239f13e0720376664a2c1850848ef3af415b92", setOf(
        ResourceItem(setOf(), "${MD}font/_7f239f13e0720376664a2c1850848ef3af415b92.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-794_835_165)
internal val Res.font._809c1d91ca35001cbf575ec82c34745fb38417e5: FontResource by lazy {
      FontResource("font:_809c1d91ca35001cbf575ec82c34745fb38417e5", setOf(
        ResourceItem(setOf(), "${MD}font/_809c1d91ca35001cbf575ec82c34745fb38417e5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_782_938_322)
internal val Res.font._8112666cad239c9e52e3e2f995b2e3e2b510821b: FontResource by lazy {
      FontResource("font:_8112666cad239c9e52e3e2f995b2e3e2b510821b", setOf(
        ResourceItem(setOf(), "${MD}font/_8112666cad239c9e52e3e2f995b2e3e2b510821b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(53_824_802)
internal val Res.font._812c15e139eb2726c8691163d5ffdc00c37337b7: FontResource by lazy {
      FontResource("font:_812c15e139eb2726c8691163d5ffdc00c37337b7", setOf(
        ResourceItem(setOf(), "${MD}font/_812c15e139eb2726c8691163d5ffdc00c37337b7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-460_117_248)
internal val Res.font._8177ec9858c77fa2adf6359e3a6a8775e9b60f86: FontResource by lazy {
      FontResource("font:_8177ec9858c77fa2adf6359e3a6a8775e9b60f86", setOf(
        ResourceItem(setOf(), "${MD}font/_8177ec9858c77fa2adf6359e3a6a8775e9b60f86.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(514_191_154)
internal val Res.font._81db2ed00836c1bd70b9b1694adb62214c15a75f: FontResource by lazy {
      FontResource("font:_81db2ed00836c1bd70b9b1694adb62214c15a75f", setOf(
        ResourceItem(setOf(), "${MD}font/_81db2ed00836c1bd70b9b1694adb62214c15a75f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_236_740_871)
internal val Res.font._831ff426f73d6fe7724212c13923fb05d952b466: FontResource by lazy {
      FontResource("font:_831ff426f73d6fe7724212c13923fb05d952b466", setOf(
        ResourceItem(setOf(), "${MD}font/_831ff426f73d6fe7724212c13923fb05d952b466.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_665_312_409)
internal val Res.font._83b1269f1b4205ea4ff05e355c8f30bb6620d7d0: FontResource by lazy {
      FontResource("font:_83b1269f1b4205ea4ff05e355c8f30bb6620d7d0", setOf(
        ResourceItem(setOf(), "${MD}font/_83b1269f1b4205ea4ff05e355c8f30bb6620d7d0.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_100_265_382)
internal val Res.font._8435d1bc82855eaa77f4d198a9c9cba985141d45: FontResource by lazy {
      FontResource("font:_8435d1bc82855eaa77f4d198a9c9cba985141d45", setOf(
        ResourceItem(setOf(), "${MD}font/_8435d1bc82855eaa77f4d198a9c9cba985141d45.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_165_619_357)
internal val Res.font._845725febe44710b9d957a1fb3300ec10b2cce36: FontResource by lazy {
      FontResource("font:_845725febe44710b9d957a1fb3300ec10b2cce36", setOf(
        ResourceItem(setOf(), "${MD}font/_845725febe44710b9d957a1fb3300ec10b2cce36.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_449_300_718)
internal val Res.font._8606f12875c7ccb7199f3652646f86bf8dedf504: FontResource by lazy {
      FontResource("font:_8606f12875c7ccb7199f3652646f86bf8dedf504", setOf(
        ResourceItem(setOf(), "${MD}font/_8606f12875c7ccb7199f3652646f86bf8dedf504.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(626_150_481)
internal val Res.font._8623bc236d00ba28c996361e4d9db5860332a7f5: FontResource by lazy {
      FontResource("font:_8623bc236d00ba28c996361e4d9db5860332a7f5", setOf(
        ResourceItem(setOf(), "${MD}font/_8623bc236d00ba28c996361e4d9db5860332a7f5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_081_907_411)
internal val Res.font._8936214898815f741efa6123b87b2695dc5a6dcf: FontResource by lazy {
      FontResource("font:_8936214898815f741efa6123b87b2695dc5a6dcf", setOf(
        ResourceItem(setOf(), "${MD}font/_8936214898815f741efa6123b87b2695dc5a6dcf.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(306_610_109)
internal val Res.font._8b52bb01d6e9e8cbc44b977847b2e6ed82b45a88: FontResource by lazy {
      FontResource("font:_8b52bb01d6e9e8cbc44b977847b2e6ed82b45a88", setOf(
        ResourceItem(setOf(), "${MD}font/_8b52bb01d6e9e8cbc44b977847b2e6ed82b45a88.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_345_496_926)
internal val Res.font._8b6d1f00c672611d0611f484588a7b35edc3421a: FontResource by lazy {
      FontResource("font:_8b6d1f00c672611d0611f484588a7b35edc3421a", setOf(
        ResourceItem(setOf(), "${MD}font/_8b6d1f00c672611d0611f484588a7b35edc3421a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_733_351_859)
internal val Res.font._8b79099b796cad3f8abd7597356ec52ac4f33d6c: FontResource by lazy {
      FontResource("font:_8b79099b796cad3f8abd7597356ec52ac4f33d6c", setOf(
        ResourceItem(setOf(), "${MD}font/_8b79099b796cad3f8abd7597356ec52ac4f33d6c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_147_427_511)
internal val Res.font._8b8da0414fcc6493ff8d95a8598d56ab91f560d1: FontResource by lazy {
      FontResource("font:_8b8da0414fcc6493ff8d95a8598d56ab91f560d1", setOf(
        ResourceItem(setOf(), "${MD}font/_8b8da0414fcc6493ff8d95a8598d56ab91f560d1.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-107_382_550)
internal val Res.font._8bdc6d2014e69a99d30751c281b76179c19e1952: FontResource by lazy {
      FontResource("font:_8bdc6d2014e69a99d30751c281b76179c19e1952", setOf(
        ResourceItem(setOf(), "${MD}font/_8bdc6d2014e69a99d30751c281b76179c19e1952.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_982_377_902)
internal val Res.font._8c5bf800d80723e6ac0799099fe9f688b12ace1f: FontResource by lazy {
      FontResource("font:_8c5bf800d80723e6ac0799099fe9f688b12ace1f", setOf(
        ResourceItem(setOf(), "${MD}font/_8c5bf800d80723e6ac0799099fe9f688b12ace1f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-872_480_549)
internal val Res.font._8cad2ad5fd37266aecdbfa6feabfac517f5b2dfb: FontResource by lazy {
      FontResource("font:_8cad2ad5fd37266aecdbfa6feabfac517f5b2dfb", setOf(
        ResourceItem(setOf(), "${MD}font/_8cad2ad5fd37266aecdbfa6feabfac517f5b2dfb.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-102_989_812)
internal val Res.font._8d172fa604e8698dc6b7bbedb8dfd0758494d586: FontResource by lazy {
      FontResource("font:_8d172fa604e8698dc6b7bbedb8dfd0758494d586", setOf(
        ResourceItem(setOf(), "${MD}font/_8d172fa604e8698dc6b7bbedb8dfd0758494d586.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_813_127_644)
internal val Res.font._8e46527c33f897d82ec8301910c979d42a0db68e: FontResource by lazy {
      FontResource("font:_8e46527c33f897d82ec8301910c979d42a0db68e", setOf(
        ResourceItem(setOf(), "${MD}font/_8e46527c33f897d82ec8301910c979d42a0db68e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_004_889_337)
internal val Res.font._8e90bdee43b51b3c6dc7b5e6b2cec7972827547a: FontResource by lazy {
      FontResource("font:_8e90bdee43b51b3c6dc7b5e6b2cec7972827547a", setOf(
        ResourceItem(setOf(), "${MD}font/_8e90bdee43b51b3c6dc7b5e6b2cec7972827547a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_896_987_257)
internal val Res.font._91477133194127d5ce758079f6406d0d5eeb4776: FontResource by lazy {
      FontResource("font:_91477133194127d5ce758079f6406d0d5eeb4776", setOf(
        ResourceItem(setOf(), "${MD}font/_91477133194127d5ce758079f6406d0d5eeb4776.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_570_771_712)
internal val Res.font._919955ff21d7da23ef35e13c680d2245691d4ffe: FontResource by lazy {
      FontResource("font:_919955ff21d7da23ef35e13c680d2245691d4ffe", setOf(
        ResourceItem(setOf(), "${MD}font/_919955ff21d7da23ef35e13c680d2245691d4ffe.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-866_469_500)
internal val Res.font._93d88295747db5b53c011b3404b145eda126df6c: FontResource by lazy {
      FontResource("font:_93d88295747db5b53c011b3404b145eda126df6c", setOf(
        ResourceItem(setOf(), "${MD}font/_93d88295747db5b53c011b3404b145eda126df6c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(227_461_234)
internal val Res.font._94290898a752f0648b001ddef8563be86d09bf37: FontResource by lazy {
      FontResource("font:_94290898a752f0648b001ddef8563be86d09bf37", setOf(
        ResourceItem(setOf(), "${MD}font/_94290898a752f0648b001ddef8563be86d09bf37.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_351_869_190)
internal val Res.font._945c1ffd3c1bde5ae04f9aa786eb08f10af246c3: FontResource by lazy {
      FontResource("font:_945c1ffd3c1bde5ae04f9aa786eb08f10af246c3", setOf(
        ResourceItem(setOf(), "${MD}font/_945c1ffd3c1bde5ae04f9aa786eb08f10af246c3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_104_291_102)
internal val Res.font._94796b8550a4a4b7a8896f5f3652c3c23009aeac: FontResource by lazy {
      FontResource("font:_94796b8550a4a4b7a8896f5f3652c3c23009aeac", setOf(
        ResourceItem(setOf(), "${MD}font/_94796b8550a4a4b7a8896f5f3652c3c23009aeac.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_099_446_388)
internal val Res.font._94c2e686f578b706b2342e7e048edb555af24122: FontResource by lazy {
      FontResource("font:_94c2e686f578b706b2342e7e048edb555af24122", setOf(
        ResourceItem(setOf(), "${MD}font/_94c2e686f578b706b2342e7e048edb555af24122.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_330_207_612)
internal val Res.font._9530d43c6d37774c67d4473a3575dc5c68c9f2f9: FontResource by lazy {
      FontResource("font:_9530d43c6d37774c67d4473a3575dc5c68c9f2f9", setOf(
        ResourceItem(setOf(), "${MD}font/_9530d43c6d37774c67d4473a3575dc5c68c9f2f9.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(990_703_735)
internal val Res.font._99d4e3f65b43bbf815efb41407601945842d7cab: FontResource by lazy {
      FontResource("font:_99d4e3f65b43bbf815efb41407601945842d7cab", setOf(
        ResourceItem(setOf(), "${MD}font/_99d4e3f65b43bbf815efb41407601945842d7cab.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_988_054_420)
internal val Res.font._9a1a45bf92e6d487fb4d58d1d9cb27c48c263853: FontResource by lazy {
      FontResource("font:_9a1a45bf92e6d487fb4d58d1d9cb27c48c263853", setOf(
        ResourceItem(setOf(), "${MD}font/_9a1a45bf92e6d487fb4d58d1d9cb27c48c263853.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_821_166_596)
internal val Res.font._9a547940d8f18a70359638377ea3fdb1170fdc7f: FontResource by lazy {
      FontResource("font:_9a547940d8f18a70359638377ea3fdb1170fdc7f", setOf(
        ResourceItem(setOf(), "${MD}font/_9a547940d8f18a70359638377ea3fdb1170fdc7f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(653_917_621)
internal val Res.font._9a69c55f264776b130abc1fcb934ffc452e60622: FontResource by lazy {
      FontResource("font:_9a69c55f264776b130abc1fcb934ffc452e60622", setOf(
        ResourceItem(setOf(), "${MD}font/_9a69c55f264776b130abc1fcb934ffc452e60622.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_348_058_398)
internal val Res.font._a0a29f061b456bad00270982eed16fcdb47f46f5: FontResource by lazy {
      FontResource("font:_a0a29f061b456bad00270982eed16fcdb47f46f5", setOf(
        ResourceItem(setOf(), "${MD}font/_a0a29f061b456bad00270982eed16fcdb47f46f5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_678_617_073)
internal val Res.font._a12ed7859bda20c79d2e1eb839de6a91bd8a89fe: FontResource by lazy {
      FontResource("font:_a12ed7859bda20c79d2e1eb839de6a91bd8a89fe", setOf(
        ResourceItem(setOf(), "${MD}font/_a12ed7859bda20c79d2e1eb839de6a91bd8a89fe.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_860_589_694)
internal val Res.font._a3df77ee5c9260bdfebcd85a270a9293c2733a6d: FontResource by lazy {
      FontResource("font:_a3df77ee5c9260bdfebcd85a270a9293c2733a6d", setOf(
        ResourceItem(setOf(), "${MD}font/_a3df77ee5c9260bdfebcd85a270a9293c2733a6d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(221_817_189)
internal val Res.font._a3e7a5e4d46f81cd60cbecb49f34f9802c6b1962: FontResource by lazy {
      FontResource("font:_a3e7a5e4d46f81cd60cbecb49f34f9802c6b1962", setOf(
        ResourceItem(setOf(), "${MD}font/_a3e7a5e4d46f81cd60cbecb49f34f9802c6b1962.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(916_763_035)
internal val Res.font._a4441bef283d28f18c5b14aa20b55fa62e911075: FontResource by lazy {
      FontResource("font:_a4441bef283d28f18c5b14aa20b55fa62e911075", setOf(
        ResourceItem(setOf(), "${MD}font/_a4441bef283d28f18c5b14aa20b55fa62e911075.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_330_695_709)
internal val Res.font._a53a59eae56e20027b616fa253e59b5e5a8b4df7: FontResource by lazy {
      FontResource("font:_a53a59eae56e20027b616fa253e59b5e5a8b4df7", setOf(
        ResourceItem(setOf(), "${MD}font/_a53a59eae56e20027b616fa253e59b5e5a8b4df7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(232_596_293)
internal val Res.font._ad3f802d6f03ad1677546207d93d1d673fd3b0c2: FontResource by lazy {
      FontResource("font:_ad3f802d6f03ad1677546207d93d1d673fd3b0c2", setOf(
        ResourceItem(setOf(), "${MD}font/_ad3f802d6f03ad1677546207d93d1d673fd3b0c2.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(690_480_659)
internal val Res.font._af0dde6ffa3438460aa429ef4849374371dcebea: FontResource by lazy {
      FontResource("font:_af0dde6ffa3438460aa429ef4849374371dcebea", setOf(
        ResourceItem(setOf(), "${MD}font/_af0dde6ffa3438460aa429ef4849374371dcebea.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_065_885_343)
internal val Res.font._af23368a94eff7d6d4d8233deb7946e92b5a4c70: FontResource by lazy {
      FontResource("font:_af23368a94eff7d6d4d8233deb7946e92b5a4c70", setOf(
        ResourceItem(setOf(), "${MD}font/_af23368a94eff7d6d4d8233deb7946e92b5a4c70.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-717_492_969)
internal val Res.font._b1c69d897b401a7882879cd989d0f2d6c62673a9: FontResource by lazy {
      FontResource("font:_b1c69d897b401a7882879cd989d0f2d6c62673a9", setOf(
        ResourceItem(setOf(), "${MD}font/_b1c69d897b401a7882879cd989d0f2d6c62673a9.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_159_294_233)
internal val Res.font._b44ba9f257671bb466db0a39f7bf0185f70ce56a: FontResource by lazy {
      FontResource("font:_b44ba9f257671bb466db0a39f7bf0185f70ce56a", setOf(
        ResourceItem(setOf(), "${MD}font/_b44ba9f257671bb466db0a39f7bf0185f70ce56a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_488_281_536)
internal val Res.font._b4ee64f2e44d2c44c643114ea8ff41b54aa62da6: FontResource by lazy {
      FontResource("font:_b4ee64f2e44d2c44c643114ea8ff41b54aa62da6", setOf(
        ResourceItem(setOf(), "${MD}font/_b4ee64f2e44d2c44c643114ea8ff41b54aa62da6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_950_286_987)
internal val Res.font._b949fdcb707234f5f9cf080a4ddfa18077fc5772: FontResource by lazy {
      FontResource("font:_b949fdcb707234f5f9cf080a4ddfa18077fc5772", setOf(
        ResourceItem(setOf(), "${MD}font/_b949fdcb707234f5f9cf080a4ddfa18077fc5772.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-815_657_472)
internal val Res.font._b9a87e686d057d4a8f2e817b9aeb11736b0b5418: FontResource by lazy {
      FontResource("font:_b9a87e686d057d4a8f2e817b9aeb11736b0b5418", setOf(
        ResourceItem(setOf(), "${MD}font/_b9a87e686d057d4a8f2e817b9aeb11736b0b5418.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_364_513_250)
internal val Res.font._badf676f31e42979af248093b6d8283d91f53097: FontResource by lazy {
      FontResource("font:_badf676f31e42979af248093b6d8283d91f53097", setOf(
        ResourceItem(setOf(), "${MD}font/_badf676f31e42979af248093b6d8283d91f53097.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_975_270_441)
internal val Res.font._be42f034e5adc17849ad62ea8416bd0aae89c790: FontResource by lazy {
      FontResource("font:_be42f034e5adc17849ad62ea8416bd0aae89c790", setOf(
        ResourceItem(setOf(), "${MD}font/_be42f034e5adc17849ad62ea8416bd0aae89c790.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_065_920_096)
internal val Res.font._be803f2f22bf923c84a0e7739c24fdf4fa844645: FontResource by lazy {
      FontResource("font:_be803f2f22bf923c84a0e7739c24fdf4fa844645", setOf(
        ResourceItem(setOf(), "${MD}font/_be803f2f22bf923c84a0e7739c24fdf4fa844645.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_575_304_322)
internal val Res.font._bf0a1155e94eba16751c92d15a9247f71ddc661c: FontResource by lazy {
      FontResource("font:_bf0a1155e94eba16751c92d15a9247f71ddc661c", setOf(
        ResourceItem(setOf(), "${MD}font/_bf0a1155e94eba16751c92d15a9247f71ddc661c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_329_305_421)
internal val Res.font._bf4bd49dce4f38fe68b7e3fbdf7d1fabbadf5c18: FontResource by lazy {
      FontResource("font:_bf4bd49dce4f38fe68b7e3fbdf7d1fabbadf5c18", setOf(
        ResourceItem(setOf(), "${MD}font/_bf4bd49dce4f38fe68b7e3fbdf7d1fabbadf5c18.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-301_434_062)
internal val Res.font._c107f94f4b9077aac047ccd3d9091d071c4e5910: FontResource by lazy {
      FontResource("font:_c107f94f4b9077aac047ccd3d9091d071c4e5910", setOf(
        ResourceItem(setOf(), "${MD}font/_c107f94f4b9077aac047ccd3d9091d071c4e5910.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_161_601_974)
internal val Res.font._c1356f54efbfa18f801ed39250c233f8075c7410: FontResource by lazy {
      FontResource("font:_c1356f54efbfa18f801ed39250c233f8075c7410", setOf(
        ResourceItem(setOf(), "${MD}font/_c1356f54efbfa18f801ed39250c233f8075c7410.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_878_283_809)
internal val Res.font._c1acbefcc09572138f93e6e522fbdcd61836eae6: FontResource by lazy {
      FontResource("font:_c1acbefcc09572138f93e6e522fbdcd61836eae6", setOf(
        ResourceItem(setOf(), "${MD}font/_c1acbefcc09572138f93e6e522fbdcd61836eae6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(448_854_234)
internal val Res.font._c1dec0543249d027822f4abbf436baa2adec8252: FontResource by lazy {
      FontResource("font:_c1dec0543249d027822f4abbf436baa2adec8252", setOf(
        ResourceItem(setOf(), "${MD}font/_c1dec0543249d027822f4abbf436baa2adec8252.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_487_487_638)
internal val Res.font._c2072911a45cee50e9715235f3c8dc4025b1173f: FontResource by lazy {
      FontResource("font:_c2072911a45cee50e9715235f3c8dc4025b1173f", setOf(
        ResourceItem(setOf(), "${MD}font/_c2072911a45cee50e9715235f3c8dc4025b1173f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-841_534_439)
internal val Res.font._c2346bae0b1554a4ec70c9653f56f85f8a5dbedf: FontResource by lazy {
      FontResource("font:_c2346bae0b1554a4ec70c9653f56f85f8a5dbedf", setOf(
        ResourceItem(setOf(), "${MD}font/_c2346bae0b1554a4ec70c9653f56f85f8a5dbedf.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(708_922_298)
internal val Res.font._c287912633beb7e8a9f70fa571f856b68cb406b0: FontResource by lazy {
      FontResource("font:_c287912633beb7e8a9f70fa571f856b68cb406b0", setOf(
        ResourceItem(setOf(), "${MD}font/_c287912633beb7e8a9f70fa571f856b68cb406b0.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_890_981_008)
internal val Res.font._c361bf27fa3a322fac309e61cbfd7270bf5b1bf0: FontResource by lazy {
      FontResource("font:_c361bf27fa3a322fac309e61cbfd7270bf5b1bf0", setOf(
        ResourceItem(setOf(), "${MD}font/_c361bf27fa3a322fac309e61cbfd7270bf5b1bf0.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(355_569_369)
internal val Res.font._c3b7eff2ceb4bac90b888e0f1c8ff535b05196f9: FontResource by lazy {
      FontResource("font:_c3b7eff2ceb4bac90b888e0f1c8ff535b05196f9", setOf(
        ResourceItem(setOf(), "${MD}font/_c3b7eff2ceb4bac90b888e0f1c8ff535b05196f9.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(801_261_041)
internal val Res.font._c4209c41ec209212d1607006cab0d54d776f1a4a: FontResource by lazy {
      FontResource("font:_c4209c41ec209212d1607006cab0d54d776f1a4a", setOf(
        ResourceItem(setOf(), "${MD}font/_c4209c41ec209212d1607006cab0d54d776f1a4a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_356_008_743)
internal val Res.font._c429305ac6ac8d5b656334e10c471607555a251b: FontResource by lazy {
      FontResource("font:_c429305ac6ac8d5b656334e10c471607555a251b", setOf(
        ResourceItem(setOf(), "${MD}font/_c429305ac6ac8d5b656334e10c471607555a251b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_053_602_960)
internal val Res.font._c4ed795b62da11bb365c9e7261f1de1bcfd82dab: FontResource by lazy {
      FontResource("font:_c4ed795b62da11bb365c9e7261f1de1bcfd82dab", setOf(
        ResourceItem(setOf(), "${MD}font/_c4ed795b62da11bb365c9e7261f1de1bcfd82dab.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-207_732_447)
internal val Res.font._c517e12169bcd098b96935c136612714d488318e: FontResource by lazy {
      FontResource("font:_c517e12169bcd098b96935c136612714d488318e", setOf(
        ResourceItem(setOf(), "${MD}font/_c517e12169bcd098b96935c136612714d488318e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_059_495_947)
internal val Res.font._c52dbd8c62f5a8d09c8b44bbad893e080dfd2935: FontResource by lazy {
      FontResource("font:_c52dbd8c62f5a8d09c8b44bbad893e080dfd2935", setOf(
        ResourceItem(setOf(), "${MD}font/_c52dbd8c62f5a8d09c8b44bbad893e080dfd2935.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-903_692_509)
internal val Res.font._c6d37437a8024948b2270efeaa624e04ad1997a3: FontResource by lazy {
      FontResource("font:_c6d37437a8024948b2270efeaa624e04ad1997a3", setOf(
        ResourceItem(setOf(), "${MD}font/_c6d37437a8024948b2270efeaa624e04ad1997a3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_650_438_396)
internal val Res.font._c6e7e86fbde70a68a7e7dc05e1b288a76e852996: FontResource by lazy {
      FontResource("font:_c6e7e86fbde70a68a7e7dc05e1b288a76e852996", setOf(
        ResourceItem(setOf(), "${MD}font/_c6e7e86fbde70a68a7e7dc05e1b288a76e852996.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_770_065_400)
internal val Res.font._c79cb31a79597aa1915e8868aca68a45cfd1f212: FontResource by lazy {
      FontResource("font:_c79cb31a79597aa1915e8868aca68a45cfd1f212", setOf(
        ResourceItem(setOf(), "${MD}font/_c79cb31a79597aa1915e8868aca68a45cfd1f212.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_955_589_427)
internal val Res.font._c7a5e3f88d5bdcc9aae7464f66e4c6f0b20f569e: FontResource by lazy {
      FontResource("font:_c7a5e3f88d5bdcc9aae7464f66e4c6f0b20f569e", setOf(
        ResourceItem(setOf(), "${MD}font/_c7a5e3f88d5bdcc9aae7464f66e4c6f0b20f569e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(119_234_983)
internal val Res.font._c96e5156215370d3f57a74cfb841b1b1f87df26a: FontResource by lazy {
      FontResource("font:_c96e5156215370d3f57a74cfb841b1b1f87df26a", setOf(
        ResourceItem(setOf(), "${MD}font/_c96e5156215370d3f57a74cfb841b1b1f87df26a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_407_064_657)
internal val Res.font._ca3ff1cbc96885a464889d4d5fd998ce1ba6bd98: FontResource by lazy {
      FontResource("font:_ca3ff1cbc96885a464889d4d5fd998ce1ba6bd98", setOf(
        ResourceItem(setOf(), "${MD}font/_ca3ff1cbc96885a464889d4d5fd998ce1ba6bd98.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_036_869_445)
internal val Res.font._cb0faab8ec421d868312a975c2cc3c47a5c1f436: FontResource by lazy {
      FontResource("font:_cb0faab8ec421d868312a975c2cc3c47a5c1f436", setOf(
        ResourceItem(setOf(), "${MD}font/_cb0faab8ec421d868312a975c2cc3c47a5c1f436.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_959_626_182)
internal val Res.font._cb8a433720b533fd96dbe7ac83542328a67ce1de: FontResource by lazy {
      FontResource("font:_cb8a433720b533fd96dbe7ac83542328a67ce1de", setOf(
        ResourceItem(setOf(), "${MD}font/_cb8a433720b533fd96dbe7ac83542328a67ce1de.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-704_881_211)
internal val Res.font._cc18889c9b6b44d79285c3fd84f7eab24832e14c: FontResource by lazy {
      FontResource("font:_cc18889c9b6b44d79285c3fd84f7eab24832e14c", setOf(
        ResourceItem(setOf(), "${MD}font/_cc18889c9b6b44d79285c3fd84f7eab24832e14c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(974_634_239)
internal val Res.font._cfa4f94dadc8424ad90854f1ad9d0b256d83ceea: FontResource by lazy {
      FontResource("font:_cfa4f94dadc8424ad90854f1ad9d0b256d83ceea", setOf(
        ResourceItem(setOf(), "${MD}font/_cfa4f94dadc8424ad90854f1ad9d0b256d83ceea.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(603_134_095)
internal val Res.font._d06713e4edcca1bd2d6cd569a0ac42fd45174c14: FontResource by lazy {
      FontResource("font:_d06713e4edcca1bd2d6cd569a0ac42fd45174c14", setOf(
        ResourceItem(setOf(), "${MD}font/_d06713e4edcca1bd2d6cd569a0ac42fd45174c14.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-236_025_893)
internal val Res.font._d09c36a332f122c23fd5ec5469924fa399efb553: FontResource by lazy {
      FontResource("font:_d09c36a332f122c23fd5ec5469924fa399efb553", setOf(
        ResourceItem(setOf(), "${MD}font/_d09c36a332f122c23fd5ec5469924fa399efb553.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_492_001_897)
internal val Res.font._d360f30b519cf13e4301bc11fdc9efb3dec0965a: FontResource by lazy {
      FontResource("font:_d360f30b519cf13e4301bc11fdc9efb3dec0965a", setOf(
        ResourceItem(setOf(), "${MD}font/_d360f30b519cf13e4301bc11fdc9efb3dec0965a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_822_688_054)
internal val Res.font._d53494032825cb0ec4e02d3bda191a747b4ee9ef: FontResource by lazy {
      FontResource("font:_d53494032825cb0ec4e02d3bda191a747b4ee9ef", setOf(
        ResourceItem(setOf(), "${MD}font/_d53494032825cb0ec4e02d3bda191a747b4ee9ef.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-213_187_716)
internal val Res.font._d59100342a2c6e89b0d1e73c62b187553046991a: FontResource by lazy {
      FontResource("font:_d59100342a2c6e89b0d1e73c62b187553046991a", setOf(
        ResourceItem(setOf(), "${MD}font/_d59100342a2c6e89b0d1e73c62b187553046991a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_388_074_086)
internal val Res.font._d63edc5c0ebf4e1849517e4d41090e3bdf36bc8a: FontResource by lazy {
      FontResource("font:_d63edc5c0ebf4e1849517e4d41090e3bdf36bc8a", setOf(
        ResourceItem(setOf(), "${MD}font/_d63edc5c0ebf4e1849517e4d41090e3bdf36bc8a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_170_035_559)
internal val Res.font._d76e3f220f2ae67de89b3139984a66f4427a27cd: FontResource by lazy {
      FontResource("font:_d76e3f220f2ae67de89b3139984a66f4427a27cd", setOf(
        ResourceItem(setOf(), "${MD}font/_d76e3f220f2ae67de89b3139984a66f4427a27cd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_148_576_363)
internal val Res.font._d8a5eb22c81738cf4e72ecaab1cc3440082b6852: FontResource by lazy {
      FontResource("font:_d8a5eb22c81738cf4e72ecaab1cc3440082b6852", setOf(
        ResourceItem(setOf(), "${MD}font/_d8a5eb22c81738cf4e72ecaab1cc3440082b6852.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(158_747_231)
internal val Res.font._d8e8c866fb28072f54d2277a87d6542bee7a4f5e: FontResource by lazy {
      FontResource("font:_d8e8c866fb28072f54d2277a87d6542bee7a4f5e", setOf(
        ResourceItem(setOf(), "${MD}font/_d8e8c866fb28072f54d2277a87d6542bee7a4f5e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_423_095_245)
internal val Res.font._d9e70497ed9ab9616588021cf29b3da4be48023d: FontResource by lazy {
      FontResource("font:_d9e70497ed9ab9616588021cf29b3da4be48023d", setOf(
        ResourceItem(setOf(), "${MD}font/_d9e70497ed9ab9616588021cf29b3da4be48023d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_464_526_618)
internal val Res.font._db5b0e0907ba587e7c52b371e77187a29923c417: FontResource by lazy {
      FontResource("font:_db5b0e0907ba587e7c52b371e77187a29923c417", setOf(
        ResourceItem(setOf(), "${MD}font/_db5b0e0907ba587e7c52b371e77187a29923c417.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-27_799_269)
internal val Res.font._dc548b917ef31650765cd71d8acf6d82ef078e64: FontResource by lazy {
      FontResource("font:_dc548b917ef31650765cd71d8acf6d82ef078e64", setOf(
        ResourceItem(setOf(), "${MD}font/_dc548b917ef31650765cd71d8acf6d82ef078e64.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-497_451_177)
internal val Res.font._dca346913762011abdaf767f3ef58c7af5e50afe: FontResource by lazy {
      FontResource("font:_dca346913762011abdaf767f3ef58c7af5e50afe", setOf(
        ResourceItem(setOf(), "${MD}font/_dca346913762011abdaf767f3ef58c7af5e50afe.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(947_781_108)
internal val Res.font._dd4d566eab1744bbbc7a1a55c04e1c5e07e6b219: FontResource by lazy {
      FontResource("font:_dd4d566eab1744bbbc7a1a55c04e1c5e07e6b219", setOf(
        ResourceItem(setOf(), "${MD}font/_dd4d566eab1744bbbc7a1a55c04e1c5e07e6b219.woff2", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont1Resources(map: MutableMap<String, FontResource>) {
  map.put("_756d208b750e0e39c40c1e574c1fe9d92f522cbd", Res.font._756d208b750e0e39c40c1e574c1fe9d92f522cbd)
  map.put("_75c454eefcd0110a37ccdad3e0ef0ffd286e7e98", Res.font._75c454eefcd0110a37ccdad3e0ef0ffd286e7e98)
  map.put("_7799fc4a0302119d4c12ddfc9b68629e0d81a27d", Res.font._7799fc4a0302119d4c12ddfc9b68629e0d81a27d)
  map.put("_78cbd767fb2e7a14b1bad1e72507edcbe070ec77", Res.font._78cbd767fb2e7a14b1bad1e72507edcbe070ec77)
  map.put("_790ba64b9d18e276e24c23fca74454a44b40453a", Res.font._790ba64b9d18e276e24c23fca74454a44b40453a)
  map.put("_791bce4e8022d749ddbda4e34f8f27f4590f6263", Res.font._791bce4e8022d749ddbda4e34f8f27f4590f6263)
  map.put("_7baf6a35b648cde51148e5558e672f31560909e8", Res.font._7baf6a35b648cde51148e5558e672f31560909e8)
  map.put("_7be772a88ffa33ed0eb5d518a1b8ebfd093edc49", Res.font._7be772a88ffa33ed0eb5d518a1b8ebfd093edc49)
  map.put("_7f239f13e0720376664a2c1850848ef3af415b92", Res.font._7f239f13e0720376664a2c1850848ef3af415b92)
  map.put("_809c1d91ca35001cbf575ec82c34745fb38417e5", Res.font._809c1d91ca35001cbf575ec82c34745fb38417e5)
  map.put("_8112666cad239c9e52e3e2f995b2e3e2b510821b", Res.font._8112666cad239c9e52e3e2f995b2e3e2b510821b)
  map.put("_812c15e139eb2726c8691163d5ffdc00c37337b7", Res.font._812c15e139eb2726c8691163d5ffdc00c37337b7)
  map.put("_8177ec9858c77fa2adf6359e3a6a8775e9b60f86", Res.font._8177ec9858c77fa2adf6359e3a6a8775e9b60f86)
  map.put("_81db2ed00836c1bd70b9b1694adb62214c15a75f", Res.font._81db2ed00836c1bd70b9b1694adb62214c15a75f)
  map.put("_831ff426f73d6fe7724212c13923fb05d952b466", Res.font._831ff426f73d6fe7724212c13923fb05d952b466)
  map.put("_83b1269f1b4205ea4ff05e355c8f30bb6620d7d0", Res.font._83b1269f1b4205ea4ff05e355c8f30bb6620d7d0)
  map.put("_8435d1bc82855eaa77f4d198a9c9cba985141d45", Res.font._8435d1bc82855eaa77f4d198a9c9cba985141d45)
  map.put("_845725febe44710b9d957a1fb3300ec10b2cce36", Res.font._845725febe44710b9d957a1fb3300ec10b2cce36)
  map.put("_8606f12875c7ccb7199f3652646f86bf8dedf504", Res.font._8606f12875c7ccb7199f3652646f86bf8dedf504)
  map.put("_8623bc236d00ba28c996361e4d9db5860332a7f5", Res.font._8623bc236d00ba28c996361e4d9db5860332a7f5)
  map.put("_8936214898815f741efa6123b87b2695dc5a6dcf", Res.font._8936214898815f741efa6123b87b2695dc5a6dcf)
  map.put("_8b52bb01d6e9e8cbc44b977847b2e6ed82b45a88", Res.font._8b52bb01d6e9e8cbc44b977847b2e6ed82b45a88)
  map.put("_8b6d1f00c672611d0611f484588a7b35edc3421a", Res.font._8b6d1f00c672611d0611f484588a7b35edc3421a)
  map.put("_8b79099b796cad3f8abd7597356ec52ac4f33d6c", Res.font._8b79099b796cad3f8abd7597356ec52ac4f33d6c)
  map.put("_8b8da0414fcc6493ff8d95a8598d56ab91f560d1", Res.font._8b8da0414fcc6493ff8d95a8598d56ab91f560d1)
  map.put("_8bdc6d2014e69a99d30751c281b76179c19e1952", Res.font._8bdc6d2014e69a99d30751c281b76179c19e1952)
  map.put("_8c5bf800d80723e6ac0799099fe9f688b12ace1f", Res.font._8c5bf800d80723e6ac0799099fe9f688b12ace1f)
  map.put("_8cad2ad5fd37266aecdbfa6feabfac517f5b2dfb", Res.font._8cad2ad5fd37266aecdbfa6feabfac517f5b2dfb)
  map.put("_8d172fa604e8698dc6b7bbedb8dfd0758494d586", Res.font._8d172fa604e8698dc6b7bbedb8dfd0758494d586)
  map.put("_8e46527c33f897d82ec8301910c979d42a0db68e", Res.font._8e46527c33f897d82ec8301910c979d42a0db68e)
  map.put("_8e90bdee43b51b3c6dc7b5e6b2cec7972827547a", Res.font._8e90bdee43b51b3c6dc7b5e6b2cec7972827547a)
  map.put("_91477133194127d5ce758079f6406d0d5eeb4776", Res.font._91477133194127d5ce758079f6406d0d5eeb4776)
  map.put("_919955ff21d7da23ef35e13c680d2245691d4ffe", Res.font._919955ff21d7da23ef35e13c680d2245691d4ffe)
  map.put("_93d88295747db5b53c011b3404b145eda126df6c", Res.font._93d88295747db5b53c011b3404b145eda126df6c)
  map.put("_94290898a752f0648b001ddef8563be86d09bf37", Res.font._94290898a752f0648b001ddef8563be86d09bf37)
  map.put("_945c1ffd3c1bde5ae04f9aa786eb08f10af246c3", Res.font._945c1ffd3c1bde5ae04f9aa786eb08f10af246c3)
  map.put("_94796b8550a4a4b7a8896f5f3652c3c23009aeac", Res.font._94796b8550a4a4b7a8896f5f3652c3c23009aeac)
  map.put("_94c2e686f578b706b2342e7e048edb555af24122", Res.font._94c2e686f578b706b2342e7e048edb555af24122)
  map.put("_9530d43c6d37774c67d4473a3575dc5c68c9f2f9", Res.font._9530d43c6d37774c67d4473a3575dc5c68c9f2f9)
  map.put("_99d4e3f65b43bbf815efb41407601945842d7cab", Res.font._99d4e3f65b43bbf815efb41407601945842d7cab)
  map.put("_9a1a45bf92e6d487fb4d58d1d9cb27c48c263853", Res.font._9a1a45bf92e6d487fb4d58d1d9cb27c48c263853)
  map.put("_9a547940d8f18a70359638377ea3fdb1170fdc7f", Res.font._9a547940d8f18a70359638377ea3fdb1170fdc7f)
  map.put("_9a69c55f264776b130abc1fcb934ffc452e60622", Res.font._9a69c55f264776b130abc1fcb934ffc452e60622)
  map.put("_a0a29f061b456bad00270982eed16fcdb47f46f5", Res.font._a0a29f061b456bad00270982eed16fcdb47f46f5)
  map.put("_a12ed7859bda20c79d2e1eb839de6a91bd8a89fe", Res.font._a12ed7859bda20c79d2e1eb839de6a91bd8a89fe)
  map.put("_a3df77ee5c9260bdfebcd85a270a9293c2733a6d", Res.font._a3df77ee5c9260bdfebcd85a270a9293c2733a6d)
  map.put("_a3e7a5e4d46f81cd60cbecb49f34f9802c6b1962", Res.font._a3e7a5e4d46f81cd60cbecb49f34f9802c6b1962)
  map.put("_a4441bef283d28f18c5b14aa20b55fa62e911075", Res.font._a4441bef283d28f18c5b14aa20b55fa62e911075)
  map.put("_a53a59eae56e20027b616fa253e59b5e5a8b4df7", Res.font._a53a59eae56e20027b616fa253e59b5e5a8b4df7)
  map.put("_ad3f802d6f03ad1677546207d93d1d673fd3b0c2", Res.font._ad3f802d6f03ad1677546207d93d1d673fd3b0c2)
  map.put("_af0dde6ffa3438460aa429ef4849374371dcebea", Res.font._af0dde6ffa3438460aa429ef4849374371dcebea)
  map.put("_af23368a94eff7d6d4d8233deb7946e92b5a4c70", Res.font._af23368a94eff7d6d4d8233deb7946e92b5a4c70)
  map.put("_b1c69d897b401a7882879cd989d0f2d6c62673a9", Res.font._b1c69d897b401a7882879cd989d0f2d6c62673a9)
  map.put("_b44ba9f257671bb466db0a39f7bf0185f70ce56a", Res.font._b44ba9f257671bb466db0a39f7bf0185f70ce56a)
  map.put("_b4ee64f2e44d2c44c643114ea8ff41b54aa62da6", Res.font._b4ee64f2e44d2c44c643114ea8ff41b54aa62da6)
  map.put("_b949fdcb707234f5f9cf080a4ddfa18077fc5772", Res.font._b949fdcb707234f5f9cf080a4ddfa18077fc5772)
  map.put("_b9a87e686d057d4a8f2e817b9aeb11736b0b5418", Res.font._b9a87e686d057d4a8f2e817b9aeb11736b0b5418)
  map.put("_badf676f31e42979af248093b6d8283d91f53097", Res.font._badf676f31e42979af248093b6d8283d91f53097)
  map.put("_be42f034e5adc17849ad62ea8416bd0aae89c790", Res.font._be42f034e5adc17849ad62ea8416bd0aae89c790)
  map.put("_be803f2f22bf923c84a0e7739c24fdf4fa844645", Res.font._be803f2f22bf923c84a0e7739c24fdf4fa844645)
  map.put("_bf0a1155e94eba16751c92d15a9247f71ddc661c", Res.font._bf0a1155e94eba16751c92d15a9247f71ddc661c)
  map.put("_bf4bd49dce4f38fe68b7e3fbdf7d1fabbadf5c18", Res.font._bf4bd49dce4f38fe68b7e3fbdf7d1fabbadf5c18)
  map.put("_c107f94f4b9077aac047ccd3d9091d071c4e5910", Res.font._c107f94f4b9077aac047ccd3d9091d071c4e5910)
  map.put("_c1356f54efbfa18f801ed39250c233f8075c7410", Res.font._c1356f54efbfa18f801ed39250c233f8075c7410)
  map.put("_c1acbefcc09572138f93e6e522fbdcd61836eae6", Res.font._c1acbefcc09572138f93e6e522fbdcd61836eae6)
  map.put("_c1dec0543249d027822f4abbf436baa2adec8252", Res.font._c1dec0543249d027822f4abbf436baa2adec8252)
  map.put("_c2072911a45cee50e9715235f3c8dc4025b1173f", Res.font._c2072911a45cee50e9715235f3c8dc4025b1173f)
  map.put("_c2346bae0b1554a4ec70c9653f56f85f8a5dbedf", Res.font._c2346bae0b1554a4ec70c9653f56f85f8a5dbedf)
  map.put("_c287912633beb7e8a9f70fa571f856b68cb406b0", Res.font._c287912633beb7e8a9f70fa571f856b68cb406b0)
  map.put("_c361bf27fa3a322fac309e61cbfd7270bf5b1bf0", Res.font._c361bf27fa3a322fac309e61cbfd7270bf5b1bf0)
  map.put("_c3b7eff2ceb4bac90b888e0f1c8ff535b05196f9", Res.font._c3b7eff2ceb4bac90b888e0f1c8ff535b05196f9)
  map.put("_c4209c41ec209212d1607006cab0d54d776f1a4a", Res.font._c4209c41ec209212d1607006cab0d54d776f1a4a)
  map.put("_c429305ac6ac8d5b656334e10c471607555a251b", Res.font._c429305ac6ac8d5b656334e10c471607555a251b)
  map.put("_c4ed795b62da11bb365c9e7261f1de1bcfd82dab", Res.font._c4ed795b62da11bb365c9e7261f1de1bcfd82dab)
  map.put("_c517e12169bcd098b96935c136612714d488318e", Res.font._c517e12169bcd098b96935c136612714d488318e)
  map.put("_c52dbd8c62f5a8d09c8b44bbad893e080dfd2935", Res.font._c52dbd8c62f5a8d09c8b44bbad893e080dfd2935)
  map.put("_c6d37437a8024948b2270efeaa624e04ad1997a3", Res.font._c6d37437a8024948b2270efeaa624e04ad1997a3)
  map.put("_c6e7e86fbde70a68a7e7dc05e1b288a76e852996", Res.font._c6e7e86fbde70a68a7e7dc05e1b288a76e852996)
  map.put("_c79cb31a79597aa1915e8868aca68a45cfd1f212", Res.font._c79cb31a79597aa1915e8868aca68a45cfd1f212)
  map.put("_c7a5e3f88d5bdcc9aae7464f66e4c6f0b20f569e", Res.font._c7a5e3f88d5bdcc9aae7464f66e4c6f0b20f569e)
  map.put("_c96e5156215370d3f57a74cfb841b1b1f87df26a", Res.font._c96e5156215370d3f57a74cfb841b1b1f87df26a)
  map.put("_ca3ff1cbc96885a464889d4d5fd998ce1ba6bd98", Res.font._ca3ff1cbc96885a464889d4d5fd998ce1ba6bd98)
  map.put("_cb0faab8ec421d868312a975c2cc3c47a5c1f436", Res.font._cb0faab8ec421d868312a975c2cc3c47a5c1f436)
  map.put("_cb8a433720b533fd96dbe7ac83542328a67ce1de", Res.font._cb8a433720b533fd96dbe7ac83542328a67ce1de)
  map.put("_cc18889c9b6b44d79285c3fd84f7eab24832e14c", Res.font._cc18889c9b6b44d79285c3fd84f7eab24832e14c)
  map.put("_cfa4f94dadc8424ad90854f1ad9d0b256d83ceea", Res.font._cfa4f94dadc8424ad90854f1ad9d0b256d83ceea)
  map.put("_d06713e4edcca1bd2d6cd569a0ac42fd45174c14", Res.font._d06713e4edcca1bd2d6cd569a0ac42fd45174c14)
  map.put("_d09c36a332f122c23fd5ec5469924fa399efb553", Res.font._d09c36a332f122c23fd5ec5469924fa399efb553)
  map.put("_d360f30b519cf13e4301bc11fdc9efb3dec0965a", Res.font._d360f30b519cf13e4301bc11fdc9efb3dec0965a)
  map.put("_d53494032825cb0ec4e02d3bda191a747b4ee9ef", Res.font._d53494032825cb0ec4e02d3bda191a747b4ee9ef)
  map.put("_d59100342a2c6e89b0d1e73c62b187553046991a", Res.font._d59100342a2c6e89b0d1e73c62b187553046991a)
  map.put("_d63edc5c0ebf4e1849517e4d41090e3bdf36bc8a", Res.font._d63edc5c0ebf4e1849517e4d41090e3bdf36bc8a)
  map.put("_d76e3f220f2ae67de89b3139984a66f4427a27cd", Res.font._d76e3f220f2ae67de89b3139984a66f4427a27cd)
  map.put("_d8a5eb22c81738cf4e72ecaab1cc3440082b6852", Res.font._d8a5eb22c81738cf4e72ecaab1cc3440082b6852)
  map.put("_d8e8c866fb28072f54d2277a87d6542bee7a4f5e", Res.font._d8e8c866fb28072f54d2277a87d6542bee7a4f5e)
  map.put("_d9e70497ed9ab9616588021cf29b3da4be48023d", Res.font._d9e70497ed9ab9616588021cf29b3da4be48023d)
  map.put("_db5b0e0907ba587e7c52b371e77187a29923c417", Res.font._db5b0e0907ba587e7c52b371e77187a29923c417)
  map.put("_dc548b917ef31650765cd71d8acf6d82ef078e64", Res.font._dc548b917ef31650765cd71d8acf6d82ef078e64)
  map.put("_dca346913762011abdaf767f3ef58c7af5e50afe", Res.font._dca346913762011abdaf767f3ef58c7af5e50afe)
  map.put("_dd4d566eab1744bbbc7a1a55c04e1c5e07e6b219", Res.font._dd4d566eab1744bbbc7a1a55c04e1c5e07e6b219)
}
